import React from 'react';
import { Grid } from '@mui/material';
import { Category, Dashboard as DashboardIcon } from '@mui/icons-material';
import { AgencyIcon } from '../AgencyIcon';

import { DashboardKpiCard } from '../dashboard/DashboardKpiCard';

export type PreferencesKpiSection = 'interest' | 'assuntos' | 'agencies';

type Props = {
  agencyInterestCount: number;
  agencyInterestLoading?: boolean;
  assuntosCount: number;
  assuntosLoading?: boolean;
  agenciesCount: number;
  agenciesLoading?: boolean;
  activeSection?: PreferencesKpiSection | null;
  onAgencyInterestClick?: () => void;
  onAssuntosClick?: () => void;
  onAgenciesClick?: () => void;
};

export function PreferencesMonitoringKpiRow({
  agencyInterestCount,
  agencyInterestLoading,
  assuntosCount,
  assuntosLoading,
  agenciesCount,
  agenciesLoading,
  activeSection,
  onAgencyInterestClick,
  onAssuntosClick,
  onAgenciesClick,
}: Props) {
  return (
    <Grid container spacing={1.5} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={4}>
        <DashboardKpiCard
          title="Agências de interesse"
          value={agencyInterestCount}
          icon={<DashboardIcon />}
          loading={agencyInterestLoading}
          barLabel="Coleta ativa"
          active={activeSection === 'interest'}
          onClick={onAgencyInterestClick}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DashboardKpiCard
          title="Assuntos monitorados"
          value={assuntosCount}
          icon={<Category />}
          loading={assuntosLoading}
          barLabel="Notificações"
          active={activeSection === 'assuntos'}
          onClick={onAssuntosClick}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DashboardKpiCard
          title="Agências monitoradas"
          value={agenciesCount}
          icon={<AgencyIcon />}
          loading={agenciesLoading}
          barLabel="Notificações"
          active={activeSection === 'agencies'}
          onClick={onAgenciesClick}
        />
      </Grid>
    </Grid>
  );
}
